<ng-container *transloco="let t;">
  <app-list-view [title]="t('common.labels.languages')" [messages]="messages" [loading]="loading">

    <div buttons>
      <button withRight="admin.language.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
      <button withRight="admin.language.create" pButton (click)="onNew()" type="button" icon="pi pi-plus" label="{{ t('common.labels.new') }}" class="p-button-success p-ml-2 p-mb-2"></button>
    </div>

    <div table>
      <p-table
        [value]="languages"
        [paginator]="true"
        [rows]="20"
        stateStorage="local"
        stateKey="language-list"
        [rowsPerPageOptions]="rowsPerPage"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="t('common.labels.current_page_report')"
      >
        <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="key">{{ t('common.labels.key') }}
                  <p-sortIcon field="key"></p-sortIcon>
              </th>
              <th pSortableColumn="name">{{ t('common.labels.name') }}
                  <p-sortIcon field="name"></p-sortIcon>
              </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-language>
            <tr (click)="onOpen(language)" (keyup.enter)="onOpen(language)" hoverOnRight="admin.language.show" tabindex="0">
              <td><span role="link">{{language.key}}</span></td>
              <td><span role="link">{{language.name}}</span></td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="4">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </app-list-view>
</ng-container>
